// @flow

import get from 'lodash/get';

//
// React
//
import React, { type Node, useState, useEffect } from 'react';

//
// Trix Middleware
//
import { get as httpGet } from '../../../../lib/trix-web-middleware-commons';

//
// Formatter
//
import { 
    fmtQuantity,
    fmtDate,
    fmtDocumentNumber,
    fmtOmni,
} from '../../../../lib/trix-web-data-commons';

//
// Type
//
// import { type CellRendererProps } from '../../../../lib/trix-web-components-table/components/table/types/CellRendererProps';

//
// Material UI
//
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import Table from '@mui/material/Table';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import TableHead from '@mui/material/TableHead';
import TableCell from '@mui/material/TableCell';

import { makeStyles } from '@mui/styles';

import clsx from 'clsx';

//
// Tools
//
const formatSkuQuantity = (trackingStrategy: string, skuQuantity: any) => {
    if (trackingStrategy === 'BUNCH') {
        return fmtQuantity(skuQuantity.quantity);
    }
    if (trackingStrategy === 'PCS') {
        return fmtQuantity(skuQuantity.quantity);
    }
    if (trackingStrategy === 'IN_BULK') {
        return `${fmtQuantity(skuQuantity.quantity)} (${fmtQuantity(skuQuantity.bulkQuantity)})`;
    }
    return 'UTS';
}

//
// Styles
//
const useStyles = makeStyles(theme => ({
    inventoryTable: {
    },
    tableRowWithoutBottomBorder: {
        '& > *': {
            borderBottom: 'unset',
        },
    },
    inventoryText: {
        fontSize: '.625rem',
    },
    inventoryDataValue: {
        whiteSpace: 'nowrap',
    },
    link: {
        color: theme.palette.primary.main,
        textDecoration: 'none',
        '&:hover': {
            cursor: 'pointer',
        },
    },
}));

const AvailabilitiesPanel = (props: { sku: string, warehouseId: string }) => {
    const [items, setItems] = useState([]);

    useEffect(() => {
        httpGet(
            // url
            `/api/v1/wms/inventory/inventory/sidInventory/search/bySkuAndWarehouse?sku=${props.sku}&warehouseId=${props.warehouseId}&page=0&size=999`,

            // options
            null,

            // reject callback
            (error) => {
            },

            // resolve callback
            (data) => {
                setItems(get(data, 'body._embedded.inventoryItems'));
            }
        )
    }, [ props.sku, props.warehouseId ]);

    return (
        <Table
            // className={classes.propertiesTable}
            size='small' 
        >
            <TableHead>
                <TableRow>
                    <TableCell>SID</TableCell>
                    <TableCell align="right">Локация</TableCell>
                    <TableCell align="right">К-во</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {(items || [])
                    .map((p, index, array) => {
                        return (
                            <TableRow 
                                key={index}
                                // className={(index === array.length - 1) ? classes.propertiesTableLastRow : null}
                            >
                                <TableCell
                                    component='th'
                                    size='small'
                                    // className={classes.propertiesText}
                                >   
                                    {p.sid}
                                </TableCell>
                                <TableCell
                                    component='th'
                                    size='small'
                                    align='right'
                                    // className={classes.propertiesText}
                                >
                                    {p.warehouseStorageLocation.name}
                                </TableCell>
                                <TableCell
                                    component='th'
                                    size='small'
                                    align='right'
                                    // className={classes.propertiesText}
                                >
                                    {
                                        formatSkuQuantity(p.stock.trackingStrategy, { 
                                            quantity: p.quantity,
                                            bulkQuantity: p.bulkQuantity
                                        })
                                    }
                                </TableCell>
                            </TableRow>
                        );
                    })
                }
            </TableBody>
        </Table>
    );
}

const StockReservationsPanel = (props: { sku: string, warehouseId: string }) => {
    const [items, setItems] = useState([]);

    useEffect(() => {
        httpGet(
            // url
            `/api/v1/wms/inventory/inventory/stockReservations/search/bySkuAndWarehouse?sku=${props.sku}&warehouseId=${props.warehouseId}&page=0&size=999`,

            // options
            null,

            // reject callback
            (error) => {
            },

            // resolve callback
            (data) => {
                setItems(get(data, 'body._embedded.stockReservations'));
            }
        )
    }, [ props.sku, props.warehouseId ]);

    return (
        <Table
            size='small' 
        >
            <TableHead>
                <TableRow>
                    <TableCell align="right">Документ</TableCell>
                    <TableCell align="right">№ / Дata</TableCell>
                    <TableCell align="right">К-во</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {(items || [])
                    .map((p, index, array) => {
                        return (
                            <TableRow 
                                key={index}
                            >
                                <TableCell
                                    component='th'
                                    size='small'
                                >   
                                    {p.document.type}
                                </TableCell>
                                <TableCell
                                    component='th'
                                    size='small'
                                    align='right'
                                >
                                    {p.document.documentNo} / {p.document.documentDate}
                                </TableCell>
                                <TableCell
                                    component='th'
                                    size='small'
                                    align='right'
                                >
                                    {
                                        formatSkuQuantity(p.stock.trackingStrategy, { 
                                            quantity: p.quantity,
                                            bulkQuantity: p.bulkQuantity
                                        })
                                    }
                                </TableCell>
                            </TableRow>
                        );
                    })
                }
            </TableBody>
        </Table>
    );
}

const StoreStockRequestsPanel = (props: { sku: string, warehouseId: string }) => {
    const [items, setItems] = useState([]);

    useEffect(() => {
        httpGet(
            // url
            `/api/v1/wms/inventory/inventory/storeStockRequests/search/bySkuAndWarehouse?sku=${props.sku}&warehouseId=${props.warehouseId}&page=0&size=999`,

            // options
            null,

            // reject callback
            (error) => {
            },

            // resolve callback
            (data) => {
                setItems(get(data, 'body._embedded.storeStockRequests'));
            }
        )
    }, [ props.sku, props.warehouseId ]);

    return (
        <Table
            size='small' 
        >
            <TableHead>
                <TableRow>
                    <TableCell align="right">Документ</TableCell>
                    <TableCell align="right">№ / Дata</TableCell>
                    <TableCell align="right">К-во</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {(items || [])
                    .map((p, index, array) => {
                        return (
                            <TableRow 
                                key={index}
                            >
                                <TableCell
                                    component='th'
                                    size='small'
                                >   
                                    {p.document.type}
                                </TableCell>
                                <TableCell
                                    component='th'
                                    size='small'
                                    align='right'
                                >
                                    {p.document.documentNo} / {p.document.documentDate}
                                </TableCell>
                                <TableCell
                                    component='th'
                                    size='small'
                                    align='right'
                                >
                                    {
                                        formatSkuQuantity(p.stock.trackingStrategy, { 
                                            quantity: p.quantity,
                                            bulkQuantity: p.bulkQuantity
                                        })
                                    }
                                </TableCell>
                            </TableRow>
                        );
                    })
                }
            </TableBody>
        </Table>
    );
}

const ShipStockRequestsPanel = (props: { sku: string, warehouseId: string }) => {
    const [items, setItems] = useState([]);

    useEffect(() => {
        httpGet(
            // url
            `/api/v1/wms/inventory/inventory/shipStockRequests/search/bySkuAndWarehouse?sku=${props.sku}&warehouseId=${props.warehouseId}&page=0&size=999`,

            // options
            null,

            // reject callback
            (error) => {
            },

            // resolve callback
            (data) => {
                setItems(get(data, 'body._embedded.shipStockRequests'));
            }
        )
    }, [ props.sku, props.warehouseId ]);

    return (
        <Table
            size='small' 
        >
            <TableHead>
                <TableRow>
                    <TableCell align="right">Документ</TableCell>
                    <TableCell align="right">№ / Дata</TableCell>
                    <TableCell align="right">К-во</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {(items || [])
                    .map((p, index, array) => {
                        return (
                            <TableRow 
                                key={index}
                            >
                                <TableCell
                                    component='th'
                                    size='small'
                                >   
                                    {p.document.type}
                                </TableCell>
                                <TableCell
                                    component='th'
                                    size='small'
                                    align='right'
                                >
                                    {p.document.documentNo} / {p.document.documentDate}
                                </TableCell>
                                <TableCell
                                    component='th'
                                    size='small'
                                    align='right'
                                >
                                    {
                                        formatSkuQuantity(p.stock.trackingStrategy, { 
                                            quantity: p.quantity,
                                            bulkQuantity: p.bulkQuantity
                                        })
                                    }
                                </TableCell>
                            </TableRow>
                        );
                    })
                }
            </TableBody>
        </Table>
    );
}

//
// Component
//
const StockInventoryRow = (props: {
    rowClassName: any,
    label: string,
    stock: any,
    skuQuantity: any,
    skuQuantityByWarehouses: any,

    handleOpenExtData: (sku: string, warehouseId: string) => void,
}) => {
    //
    // Hooks
    //
    const classes = useStyles();

    const [isInventoryDetailsVisible, setInventoryDetailsVisible] = useState(false);

    // const [openSids, setOpenSids] = useState({
    //     modalOpen: false,
    //     sku: '',
    //     warehouseId: ''
    // });
    // const handleOpenSids = (sku: string, warehouseId: string) => setOpenSids({ modalOpen: true, sku, warehouseId });
    // const handleCloseSids = () => setOpenSids({ modalOpen: false, sku: '', warehouseId: '' });

    return (
        <React.Fragment>
            <TableRow 
                className={(isInventoryDetailsVisible) ? classes.tableRowWithoutBottomBorder : props.rowClassName}
            >
                <TableCell
                    component='th'
                    size='small'
                    className={classes.inventoryText}
                >
                    {props.label}
                </TableCell>
                <TableCell 
                    size='small'
                    align='right'
                    className={clsx(classes.inventoryText, classes.inventoryDataValue)}
                >
                    <div
                        onClick={() => setInventoryDetailsVisible(!isInventoryDetailsVisible)}
                        className={clsx(classes.link)}
                    >
                        {
                            // $FlowFixMe
                            formatSkuQuantity(props.stock.trackingStrategy, props.skuQuantity)
                        }
                    </div>
                </TableCell>
            </TableRow>
            {
                (props.skuQuantityByWarehouses) ? (
                    <TableRow>
                        <TableCell
                            style={{ paddingBottom: 0, paddingTop: 0 }}
                            colSpan={2}
                        >
                            <Collapse in={isInventoryDetailsVisible} timeout="auto" unmountOnExit>
                                <Box margin={1}>
                                    <Table size="small">
                                        <TableBody>
                                            {props.skuQuantityByWarehouses.map((row, index, array) => (
                                                <TableRow 
                                                    key={index}
                                                    className={(index === array.length - 1) ? 
                                                        classes.tableRowWithoutBottomBorder : null
                                                    }
                                                >
                                                    <TableCell
                                                        component='th'
                                                        size='small'
                                                        className={classes.inventoryText}
                                                    >
                                                        {(row.warehouse) ? row.warehouse.name : 'Няма'}  
                                                    </TableCell>
                                                    <TableCell
                                                        size='small'
                                                        align='right'
                                                        className={clsx(classes.inventoryText, classes.inventoryDataValue)}
                                                    >
                                                        <div
                                                            onClick={() => props.handleOpenExtData(props.stock.sku, row.warehouse.id)}
                                                            className={clsx(classes.link)}
                                                        >
                                                            {
                                                                // $FlowFixMe
                                                                formatSkuQuantity(props.stock.trackingStrategy, row.skuQuantity)
                                                            }
                                                        </div>

                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </Box>
                            </Collapse>
                        </TableCell>
                    </TableRow>
                ) : null
            }
        </React.Fragment>
    );
}

//
// Props
//
type Props = {
    //
    // Data
    //
    stock: any,

    skuInventory: {
        storeRequestedQuantity: any,
        storeRequestedQuantityByWarehouses: any[],

        inventoryQuantity: any,
        inventoryQuantityByWarehouses: any[],

        reservedQuantity: any,
        reservedQuantityByWarehouses: any[],

        shipRequestedQuantity: any,
        shipRequestedQuantityByWarehouses: any[],
    },
};

//
// Component
//
const StockInventoryPane = (props: Props): Node => {
    //
    // Hooks
    //
    const classes = useStyles();

    const [availabilitiesData, setAvailabilitiesData] = useState({
        modalOpen: false,
        sku: '',
        warehouseId: ''
    });
    const handleOpenAvailabilities = (sku: string, warehouseId: string) => setAvailabilitiesData({ modalOpen: true, sku, warehouseId });
    const handleCloseAvailabilities = () => setAvailabilitiesData({ modalOpen: false, sku: '', warehouseId: '' });

    const [reservationsData, setReservationsData] = useState({
        modalOpen: false,
        sku: '',
        warehouseId: ''
    });
    const handleOpenReservations = (sku: string, warehouseId: string) => setReservationsData({ modalOpen: true, sku, warehouseId });
    const handleCloseReservations = () => setReservationsData({ modalOpen: false, sku: '', warehouseId: '' });

    const [storeStockRequestsData, setStoreStockRequestsData] = useState({
        modalOpen: false,
        sku: '',
        warehouseId: ''
    });
    const handleOpenStoreStockRequests = (sku: string, warehouseId: string) => setStoreStockRequestsData({ modalOpen: true, sku, warehouseId });
    const handleCloseStoreStockRequests = () => setStoreStockRequestsData({ modalOpen: false, sku: '', warehouseId: '' });

    const [shipStockRequestsData, setShipStockRequestsData] = useState({
        modalOpen: false,
        sku: '',
        warehouseId: ''
    });
    const handleOpenShipStockRequests = (sku: string, warehouseId: string) => setShipStockRequestsData({ modalOpen: true, sku, warehouseId });
    const handleCloseShipStockRequests = () => setShipStockRequestsData({ modalOpen: false, sku: '', warehouseId: '' });

    // End Hooks

    return (
        <>
            <Table 
                className={classes.inventoryTable}
                size='small' 
            >
                <TableBody>
                    {[
                        {
                            'lbl': 'Налични',
                            'skuQuantity': (props.skuInventory && props.skuInventory.inventoryQuantity) ? 
                                    props.skuInventory.inventoryQuantity : {},
                            'skuQuantityByWarehouses': (props.skuInventory && props.skuInventory.inventoryQuantityByWarehouses) ? 
                                    props.skuInventory.inventoryQuantityByWarehouses : [],
                            handleOpenExtData: handleOpenAvailabilities,
                        },
                        {
                            'lbl': 'Резервирани',
                            'skuQuantity': (props.skuInventory && props.skuInventory.reservedQuantity) ? 
                                    props.skuInventory.reservedQuantity : {},
                            'skuQuantityByWarehouses': (props.skuInventory && props.skuInventory.reservedQuantityByWarehouses) ? 
                                    props.skuInventory.reservedQuantityByWarehouses : [],
                            handleOpenExtData: handleOpenReservations
                        },
                        {
                            'lbl': 'Заявени за експедиция',
                            'skuQuantity': (props.skuInventory && props.skuInventory.shipRequestedQuantity) ? 
                                    props.skuInventory.shipRequestedQuantity : {},
                            'skuQuantityByWarehouses': (props.skuInventory && props.skuInventory.shipRequestedQuantityByWarehouses) ? 
                                    props.skuInventory.shipRequestedQuantityByWarehouses : [],
                            handleOpenExtData: handleOpenShipStockRequests
                        },
                        {
                            'lbl': 'Заявени за заприхождаване',
                            'skuQuantity': (props.skuInventory && props.skuInventory.storeRequestedQuantity) ? 
                                    props.skuInventory.storeRequestedQuantity : {},
                            'skuQuantityByWarehouses': (props.skuInventory && props.skuInventory.storeRequestedQuantityByWarehouses) ? 
                                    props.skuInventory.storeRequestedQuantityByWarehouses : [],
                            handleOpenExtData: handleOpenStoreStockRequests
                        }
                    ].map((row, index, array) => (
                        <StockInventoryRow
                            key={index}
                            rowClassName={(index === array.length - 1) ? 
                                classes.tableRowWithoutBottomBorder : null}
                            label={row.lbl}
                            stock={props.stock}
                            skuQuantity={row.skuQuantity}
                            skuQuantityByWarehouses={row.skuQuantityByWarehouses}

                            handleOpenExtData={row.handleOpenExtData}
                        />
                    ))}
                </TableBody>
            </Table>

            <Modal open={availabilitiesData.modalOpen} onClose={handleCloseAvailabilities}>
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        outline: 'none',
                        boxShadow: 24,
                        bgcolor: 'background.paper',
                        borderRadius: 2,
                        maxWidth: '90%',
                        maxHeight: '90%',
                        p: 1,
                    }}
                >
                    <AvailabilitiesPanel 
                        sku={availabilitiesData.sku}
                        warehouseId={availabilitiesData.warehouseId}
                    />
                </Box>
            </Modal>

            <Modal open={reservationsData.modalOpen} onClose={handleCloseReservations}>
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        outline: 'none',
                        boxShadow: 24,
                        bgcolor: 'background.paper',
                        borderRadius: 2,
                        maxWidth: '90%',
                        maxHeight: '90%',
                        p: 1,
                    }}
                >
                    <StockReservationsPanel 
                        sku={reservationsData.sku}
                        warehouseId={reservationsData.warehouseId}
                    />
                </Box>
            </Modal>

            <Modal open={storeStockRequestsData.modalOpen} onClose={handleCloseStoreStockRequests}>
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        outline: 'none',
                        boxShadow: 24,
                        bgcolor: 'background.paper',
                        borderRadius: 2,
                        maxWidth: '90%',
                        maxHeight: '90%',
                        p: 1,
                    }}
                >
                    <StoreStockRequestsPanel 
                        sku={storeStockRequestsData.sku}
                        warehouseId={storeStockRequestsData.warehouseId}
                    />
                </Box>
            </Modal>

            <Modal open={shipStockRequestsData.modalOpen} onClose={handleCloseShipStockRequests}>
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        outline: 'none',
                        boxShadow: 24,
                        bgcolor: 'background.paper',
                        borderRadius: 2,
                        maxWidth: '90%',
                        maxHeight: '90%',
                        p: 1,
                    }}
                >
                    <ShipStockRequestsPanel 
                        sku={shipStockRequestsData.sku}
                        warehouseId={shipStockRequestsData.warehouseId}
                    />
                </Box>
            </Modal>
        </>
    );
}
export default StockInventoryPane;
